<template>
  <el-card
    :style="{width : width, height : height }"
    shadow="hover">
    <h4>{{ title }}</h4>
    <slot/>
  </el-card>
</template>

<script>
export default {
  name: 'FormCard',
  props: {
    height: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '230px'
    },
    title: {
      type: String,
      default: '230px'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_shared/form-card.vue